// extracted by mini-css-extract-plugin
export var container = "_5b-0";
export var containerTopRight = "_5b-1";